/*
 * ===============================================================================================================
 *                                Copyright 2025, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Tokens } from '@jda/lui-common-component-library-mui5';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  dialogTitle: {
    display: 'flex',
    alignItems: 'center'
  },
  dialogTitleText: {
    flex: 1,
    fontWeight: 500
  },
  dialogContent: {
    paddingLeft: Tokens.spacing['$sp-4'],
    paddingRight: Tokens.spacing['$sp-4']
  },
  formField: {
    '&:not(:first-child)': {
      marginTop: Tokens.spacing['$sp-5']
    }
  },
  toggleSwitch: {
    paddingRight: Tokens.spacing['$sp-3']
  },
  dialogActions: {
    padding: `${Tokens.spacing['$sp-4']} !important`
  },
  dialogActionsWithAlert: {
    padding: `${Tokens.spacing['$sp-4']} !important`,
    justifyContent: 'space-between',
  },
  actionsBox: {
    display: 'flex',
    alignItems: 'flex-end'
  },
  dialogNote: {
    display: 'flex',
    alignItems: 'center'
  },
  dialogNoteIcon: {
    color: theme.palette.text.secondary
  }
}));
